import React from "react";
import { Link } from "react-router-dom";

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-gray-300 font-sans selection:bg-[#00FF41] selection:text-black">
    <nav className="border-b border-white/5 bg-black/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-3 group">
          <div className="w-10 h-10 bg-gradient-to-br from-[#00FF41] to-[#008F22] rounded-xl flex items-center justify-center group-hover:rotate-12 transition-transform duration-300 shadow-[0_0_20px_rgba(0,255,65,0.2)]">
            <span className="text-black font-black text-xl">NR</span>
          </div>
          <span className="text-xl font-bold tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400">
            NORESPECT<span className="text-[#00FF41]">DIGITAL</span>
          </span>
        </Link>
        <Link to="/" className="text-sm font-medium hover:text-[#00FF41] transition-colors">
          Back to Home
        </Link>
      </div>
    </nav>

    <div className="max-w-4xl mx-auto px-6 py-20">
      <div className="space-y-8">
        <h1 className="text-5xl font-black text-white tracking-tight uppercase">
          {title}
        </h1>
        <div className="text-gray-400 space-y-4">
          {children}
        </div>
      </div>
    </div>

    <footer className="border-t border-white/5 py-12 bg-black">
      <div className="max-w-7xl mx-auto px-6 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} NoRespectDigital. All rights reserved.
      </div>
    </footer>
  </div>
);

const Refund = () => {
  return (
    <LegalLayout title="Refund Policy">
      <section className="space-y-6">
        <p className="text-lg leading-relaxed">
          We want you to be completely satisfied with our B2B automation tools. Please read our refund policy carefully.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">1. Trial Period and Subscriptions</h2>
        <p>
          We offer various subscription tiers for our tools. If you are not satisfied with your purchase, you may request a refund within 14 days of your initial purchase, provided you have not exceeded the fair usage limits of the automation scripts.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">2. Eligibility for Refunds</h2>
        <p>
          To be eligible for a refund, you must demonstrate that the tool did not meet the described functionality or that you encountered technical issues that our support team could not resolve within a reasonable timeframe.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">3. Process for Refunds</h2>
        <p>
          Since all payments are processed via Paddle, refund requests should be initiated through our support email at support@norespect.site or directly via the Paddle customer support portal.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">4. Non-Refundable Items</h2>
        <p>
          Renewals of existing subscriptions are generally non-refundable unless cancelled prior to the billing date. Individual one-time security scans are non-refundable once the scan has been initiated.
        </p>

        <h2 className="text-2xl font-bold text-white uppercase italic">5. Cancellation</h2>
        <p>
          You may cancel your subscription at any time through your dashboard. Your access will remain active until the end of the current billing period.
        </p>

        <p className="pt-10 text-sm italic">
          Last updated: April 15, 2026
        </p>
      </section>
    </LegalLayout>
  );
};

export default Refund;
